<template>
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
      <b-col cols="12">
        <div style="margin-bottom:10px"></div>

        <div style="margin: 10px"></div>
        <b-card bg-variant="light" style="min-height: 60vh;">
          <div class="col-md-12">
            <div class="overflow-auto">
              <b-table stacked="md" id="my-table" striped small :fields="fields" :items="setores" responsive="sm">
                <template v-slot:cell(codigo)="data">
                  <span>{{ data.item.idSetor }}</span>
                </template>
                <template v-slot:cell(visualizar)="data">
                  <b-button @click="visualizar(data.item.idSetor)" class="v-button" size="sm"
                            style="background-color: #303f9f">
                    <b-icon icon="search"></b-icon>
                  </b-button>
                </template>
              </b-table>
              <div style="float: right">
              </div>
            </div>
          </div>
        </b-card>
        <br>
        <b-card bg-variant="light">
          <div class="row" style="float: right">
            <b-button v-b-modal.modal-setor style="margin-right: 30px; background-color: #303f9f">
              <b-icon icon="file-earmark"></b-icon>
              Novo
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal id="modal-setor" ref="modal" title="Setor" @hidden="resetModal" @ok="salvar">
      <b-form-group label="Descrição" label-for="descricao">
        <b-input id="descricao" v-model="setor.descricao"></b-input>
      </b-form-group>
      <b-form-group label="Código Setor - HelpDesk" label-for="setor">
        <b-input id="setor" type="number" v-model="setor.codSetorHelpDesk"></b-input>
      </b-form-group>
      <b-form-group label="Supervisor (e-mail)" label-for="supervisor">
        <b-input id="supervisor" v-model="setor.supervisor"></b-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';

export default {
  components: {BarraNavegacao},

  data() {
    return {
      setores: [],
      fields: ['descricao', 'supervisor', {key: 'visualizar', label: 'Visualizar', class: 'text-center'}],
      setor: {
        idSetor: null,
        descricao: '',
        status: 'A',
        codSetorHelpDesk: 0,
        supervisor: null
      }
    }
  },

  created() {
    this.validaAcesso();
  },

  mounted() {
    this.listar();
  },

  methods: {

    alertaMensager(mensagem, titulo, tipo) {
      this.$fire({
        title: titulo,
        text: mensagem,
        type: tipo,
      }).then(r => {
        r.value;
      });
    },

    resetModal() {
      this.setor = {idSetor: null, descricao: '', status: 'A', supervisor: null}
    },

    salvar() {
      if (this.setor.supervisor && this.setor.supervisor.trim() === '') {
        this.setor.supervisor = null;
      }

      this.$http.post('/setor', this.setor).then(res => {
        this.alertaMensager(res.data, "", "success");
        this.listar();
      })
    },

    validaAcesso() {
      this.$http.get('/gerencia', this.sala).then()
    },

    listar() {
      this.$http.get("/setor").then(res => {
        this.setores = res.data;
      })
    },

    visualizar(id) {
      this.$http.get("/setor/" + id).then(res => {
        this.setor = res.data;
        this.$bvModal.show('modal-setor');
      })
    },

  }
}

</script>

<style>

</style>
